import BasePage from "../modules/basePage";
import "../../css/pages/EoeAwarenessPage.scss";

class EoeAwarenessPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
    }
}

new EoeAwarenessPage();
